import type { NearestRelativeFormData } from "@porchpass/ui";
import type { UpdateBorrowerStatusFormData } from "src/types/borrower";
import { addCountryCode, stripCountryCode } from "src/utils";

export function toNearestRelativeFormData(
  dto: UpdateBorrowerStatusFormData,
): NearestRelativeFormData {
  return {
    nearestRelativeName: dto.nearest_relative_name,
    nearestRelativeRelationship: dto.nearest_relative_relationship,
    nearestRelativePhone: dto.nearest_relative_phone_number
      ? stripCountryCode(dto.nearest_relative_phone_number)
      : "",
  };
}

export function fromNearestRelativeFormData(
  data: NearestRelativeFormData,
): Partial<UpdateBorrowerStatusFormData> {
  return {
    nearest_relative_name: data.nearestRelativeName,
    nearest_relative_relationship: data.nearestRelativeRelationship,
    nearest_relative_phone_number: data.nearestRelativePhone,
  };
}

export function formatNearestRelativeForSubmit(
  data: NearestRelativeFormData,
): Partial<UpdateBorrowerStatusFormData> {
  const mapped = fromNearestRelativeFormData(data);

  return {
    ...mapped,
    nearest_relative_name: mapped.nearest_relative_name ?? "",
    nearest_relative_relationship: mapped.nearest_relative_relationship ?? "",
    ...(mapped.nearest_relative_phone_number
      ? {
          nearest_relative_phone_number: addCountryCode(
            mapped.nearest_relative_phone_number,
          ),
        }
      : {}),
  };
}
